import React from "react";
import styled from 'styled-components';
import {ReactComponent as LockIcon} from './imgs/lock_icon_new1_filled.svg';
import {useTranslation} from "react-i18next";
import {getInitialGroupItems} from "../../../../markets/marketMapping";

type OddsRowContainerProps = {
    containerSize: number;
};
export const OddsRowContainer = styled.div<OddsRowContainerProps>`
    display: grid;
    font-size: 14px;
    height: 100%;
    grid-template-columns: repeat(${props => props.containerSize}, 1fr);
`;
OddsRowContainer.displayName = 'OddsRowContainer';

const SelectionWrapper = styled.div<{ isLabel: boolean, isSelected?: boolean, disabled: boolean, isLast: boolean, bg: string }>`
    display: flex;
    height: 32px;
    flex-grow: 1;
    flex-basis: 0;
    justify-content: center;
    align-items: center;
    transition: box-shadow 0.15s ease; // box-shadow заменяет border 1px
    ${props => props.isLast ? 'border-radius: 0 0 8px 0' : ''};
    box-shadow: ${props => props.isSelected ? 'inset 0 0 0 1px #EACD40' : 'none'};
    background-color: ${props => props.bg};
    cursor: ${props => props.isLabel ? 'initial' : 'pointer'};
    &:hover {
        ${props => !props.isLabel ? 'box-shadow: inset 0 0 0 1px #EACD40;' : ''};
    }
    ${props => props.disabled ? 'pointer-events:none;' : ''};
    ${props => props.disabled ? 'color:#757575;' : ''};
    position: relative;
`;
SelectionWrapper.displayName = 'SelectionWrapper';

const Label = styled.div`
    text-align: center;
`;
Label.displayName = 'Label';

type SelectionBoxProps = {
    isSelected?: boolean;
    isLocked?: boolean;
    isSuspended?: boolean;
    value?: number | string;
    isLabel?: boolean;
    disabled?: boolean;
    selectionName?: string;
    isLast?: boolean;
    sport?: any;
    groups: any
}

export function SelectionBox(props: SelectionBoxProps) {
    const {isSelected, isSuspended = false, isLocked = false, value, isLabel = false, disabled = false, selectionName, isLast = false} = props;
    const [odds, setOdds] = React.useState(props.value);
    const [color, setColor] = React.useState('#fff');
    const [change, setChange] = React.useState<'up' | 'down' | null>(null);
    const [bg, setBg] = React.useState('#3A424A')
    const sleep = (ms: number) => new Promise(r => setTimeout(r, ms));
    const {t} = useTranslation();
    React.useEffect(() => {
        setOdds(value);
            if (isSuspended || isLabel || disabled) {
                setColor('#a5a4a4');
                setBg(isLabel ? '#1B1E23' : '#3A424A')
                setChange(null);
                return;
            }
            if (typeof value === "number" && typeof odds === "number") {
                if (value > odds) {
                    setBg('#1F472F');
                    setChange('up');
                } else if (value < odds) {
                    setBg('#573333');
                    setChange('down');
                } else {
                    setBg('#3A424A')
                    setChange(null);
                }
                setColor('#fff');
            }
            sleep(2000).then(() => {
                setColor('#fff');
                setBg('#3A424A');
                setChange(null);
            });
        }, [value, isSuspended, isLabel, disabled]);

    const Lock = () => isSuspended && typeof value !== "string" ? (
        <div className="mr-[3px] desktop:mr-[5px]">
            <LockIcon/>
        </div>
    ) : <></>;
    const Odds = () => (
        <span
            style={{ color }}
            className="text-[12px] desktop:text-[16px] font-bold"
        >
            {value && !isLocked ? value : '-'}
        </span>
    );


    return (
        <>
            <SelectionWrapper
                isSelected={isSelected}
                isLabel={isLabel}
                disabled={disabled}
                isLast={isLast}
                bg={bg}
                className={`rounded-[3px] ${props.groups.length > 3 ? 'max-tablet:w-[40px]' : 'max-tablet:w-[48px]'} h-[32px]`}
            >
                <div className="flex justify-between items-center">
                    <Lock />
                    <Odds />
                </div>
                {change === 'up' && (
                    <div
                        className="absolute top-0 right-0 w-[10px] h-[10px] bg-[#3ABF37] rounded-[3px]"
                        style={{ clipPath: 'polygon(100% 0, 0 0, 100% 100%)' }}
                    />
                )}

                {change === 'down' && (
                    <div
                        className="absolute bottom-0 right-0 w-0 h-0
                        border-l-[10px] border-l-transparent
                        border-b-[10px] border-b-[#FF4848] rounded-[3px]"
                    />
                )}
            </SelectionWrapper>
        </>
    );

}
